import api from 'Application/api/api';
import adaptEpcOfferResponseData from 'EpcContract/api/adapters/adaptEpcOfferResponseData';

const getEpcPartnerOfferById = async (signal, id) => {
	const response = await api.get(`/epc-offers/partner/${id}`, {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}
	return {
		...response,
		data: adaptEpcOfferResponseData(response.data),
	};
};

export default getEpcPartnerOfferById;
